import { hbs } from 'ember-cli-htmlbars';
export default hbs("<BvBtn\n  @iconLeft=\"add-circle\"\n  @color=\"primary\"\n  @subtle={{true}}\n  @onClick={{@onCreate}}\n  @tooltipText={{@tooltipText}}\n  @tooltipSide=\"top\"\n/>")